module.exports = __webpack_public_path__ + "img/logo_Edge.b37b3356.png";